import { render } from "./LifeOnLifeSupportLauncher.vue?vue&type=template&id=471ae19a&scoped=true"
import script from "./LifeOnLifeSupportLauncher.vue?vue&type=script&lang=js"
export * from "./LifeOnLifeSupportLauncher.vue?vue&type=script&lang=js"

import "./LifeOnLifeSupportLauncher.vue?vue&type=style&index=0&id=471ae19a&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471ae19a"]])

export default __exports__